import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/webimports-dev/htdocs/web-imports/src/app/servicos/[id]/ServicosDetalhesPage.tsx");
